enum CheckoutRoutes {
  CheckoutProducer = '/:country/checkout/:producerSlug',
  Checkout = '/:country/checkout',
}

export default CheckoutRoutes
